/** @jsx jsx */

import React, { useState } from 'react';
import { css, jsx } from '@emotion/core';

export const Tick = ({ width = 7, height = 6 }) => {
  return (
    <div
      css={css`
        width: ${width}px;
        height: ${height}px;
        overflow: hidden;
      `}
    >
      <svg>
        <polyline
          points={`0,${height / 2} ${width / 2},${height} ${width},0`}
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeWidth: 1,
          }}
        />
      </svg>
    </div>
  );
};

const CheckBox = ({
  label = '',
  width = 17,
  height = 17,
  on,
  onClick,
  style = {},
  ...props
}) => {
  const checkBox = (
    <div
      css={css`
        display: flex;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        width: ${width}px;
        height: ${width}px;
        border: 1px solid #28292b;
        border-radius: 50%;
        background: ${on ? '#28292B' : '#fff'};
        transition: background 0.15s;
        cursor: pointer;

        ${!label &&
          `
        &:hover {
          opacity: 0.8;
        }
        `}
      `}
      onClick={!label ? onClick : null}
    >
      <Tick />
    </div>
  );

  return label ? (
    <div
      css={css`
        display: flex;
        align-items: center;
        cursor: pointer;

        &:hover {
          opacity: 0.8;
        }

        overflow: hidden;
      `}
      style={style}
      {...props}
      onClick={onClick}
    >
      {checkBox}
      <div
        css={css`
          margin: 0 0 0 10px;
          font-size: 12px;
          color: #121416;
        `}
      >
        {label}
      </div>
    </div>
  ) : (
    checkBox
  );
};

export default CheckBox;
